import { message } from 'antd';

export const showErrorMessage = text => {
  text && message.error(text);
};

export const showSuccessMessage = text => {
  text && message.success(text);
};
